<script setup>
import _ from 'lodash-es'
import AuthLayout from '../layout/AuthLayout.vue'
import { reactive } from 'vue'
import { isValidPassword, post, validators } from '@/common/util'
import { useMetaStore, useMemberStore } from '@/stores'
import { useRouter } from 'vue-router'
const meta=reactive({findpwemail:'',loginbtnloading:false,disableid:false,disablepasswd:false}),memStore=useMemberStore(),router=useRouter()
,tpop=(msg,issucc)=>metaStore.toastKey(msg,issucc),metaStore=useMetaStore()
,findpw=(dialogActive)=>{
  metaStore.blockLoading()
  post('rest/public/resetpwandsend',{email:meta.findpwemail},resp=>{
    metaStore.blockLoading(false)
    dialogActive.value=false
    meta.findpwemail=''
    tpop(resp.msg,resp.isSuccess)
  })
},login=()=>{
  meta.disableid=meta.disablepasswd=meta.loginbtnloading=true
  post('rest/public/authenticate',{mid:meta.mid,passwd:meta.passwd},resp=>{
    meta.disableid=meta.disablepasswd=meta.loginbtnloading=false
    if(!resp.isSuccess)return tpop(resp.msg,resp.isSuccess)
    memStore.init(resp.data.jwt,resp.data.mname)
    if(memStore.iss!=='uok-gis'){
      memStore.reset()
      return tpop('invalidtoken',false)
    }
    if(resp.data.needchangepw){
      memStore.reset()
      meta.visiblechangepw=true
      return;
    }
    metaStore.toast(metaStore.t('welcome_mem').replace('_mem_',resp.data.mname),true)
    router.push('/')
  })
},changepw=()=>{
  const pd={mid:meta.mid,oldpw:meta.passwd,newpw:meta.newpasswd};
  if(pd.oldpw==pd.newpw)return tpop('previouslyusedpasswordsaredisabled',false)
  meta.disablechangepwpw=meta.disablechangepwconpw=meta.changepwbtnloading=true
  post('rest/public/changepw',pd,resp=>{
    meta.disablechangepwpw=meta.disablechangepwconpw=meta.changepwbtnloading=false
    meta.passwd=''
    meta.visiblechangepw=!resp.isSuccess
    tpop(resp.msg,resp.isSuccess)
  })
}
</script>
<template>
  <AuthLayout>
    <template #body>
      <v-text-field :disabled="meta.disableid" v-model="meta.mid" :label="$t('id')" variant="outlined" :rules="[val=>!!val||$t('pleaseenteryourid')]" :placeholder="$t('pleaseenteryourid')" @keyup.enter="login"/>
      <v-text-field :disabled="meta.disablepasswd" v-model="meta.passwd" class="mt-5 mb-5" type="password" :label="$t('password')" variant="outlined" :rules="[val=>!!val||$t('pleaseenteryourpassword')]"
        :placeholder="$t('pleaseenteryourpassword')" @keyup.enter="login"/>
      <v-btn block color="primary" :loading="meta.loginbtnloading" @click.prevent="login" :disabled="validators.required(meta.mid)!==true||validators.required(meta.passwd)!==true">{{ $t('login') }}</v-btn>
    </template>
    <template #actions>
      <v-row>
        <v-col cols="6" class="text-caption">
          {{ $t('forgotyourpassword') }}
          <v-dialog max-width="500">
            <template v-slot:activator="{ props: findpwprops }">
              <a href="javascript:" v-bind="findpwprops">{{ $t('findpasswd') }}</a>
            </template>
            <template v-slot:default="{ isActive }">
              <v-card>
                <v-card-title class="border-b-sm font-weight-black">
                  {{ $t('findpasswd') }}
                </v-card-title>
                <v-card-text class="border-b-sm">
                  <div class="text-subtitle-1">{{ $t('enter_email_with_register') }}</div>
                  <v-text-field v-model="meta.findpwemail" class="mt-1" variant="outlined" :label="$t('emailaddress')" :placeholder="$t('enteryouremailaddress')"
                    :rules="[validators.required,validators.email]"/>
                </v-card-text>
                <v-card-actions>
                  <v-btn variant="outlined" @click="isActive.value = false;meta.findpwemail=''">{{ $t('cancel') }}</v-btn>
                  <v-btn variant="flat" color="primary" @click="findpw(isActive)" :disabled="validators.required(meta.findpwemail)!==true||validators.email(meta.findpwemail)!==true">{{ $t('confirm') }}</v-btn>
                </v-card-actions>
              </v-card>
            </template>
          </v-dialog>
        </v-col>
        <v-col cols="6" class="text-caption">
          {{ $t('notamemberyet') }} <router-link to="/signup">{{ $t('signup') }}</router-link>
        </v-col>
      </v-row>
    </template>
  </AuthLayout>
  <v-dialog max-width="520" v-model="meta.visiblechangepw" persistent>
    <v-card>
      <v-card-title class="border-b-sm font-weight-black pa-5" style="text-overflow: unset;white-space: inherit;">
        <v-icon icon="mdi-lock" size="25" class="mr-2"/>{{ $t('pleasechangeyourpasswordtoprotectyourprivacy') }}
      </v-card-title>
      <v-card-text class="border-b-sm">
        <v-row no-gutters justify="center">
          <v-col cols="11">
            <v-text-field type="password" v-model="meta.newpasswd" class="mt-1" variant="outlined" :label="$t('enteranewpassword')" :placeholder="$t('pleaseenteryourpassword')"
              :rules="[isValidPassword]"/>
            <v-text-field type="password" v-model="meta.newpasswdconfirm" class="mt-2" variant="outlined" :label="$t('confirmyournewpassword')" :placeholder="$t('pleaseenteryourpasswordonemoretime')"
              :rules="[validators.required,v=>validators.retypeBefore(meta.newpasswd,v,'checksamepasscon')]"/>
          </v-col>
        </v-row>
        <v-list lines="one">
          <v-list-item :disabled="meta.disablechangepwpw" class="text-caption font-weight-black"><v-icon icon="mdi-lightbulb-outline"/> {{ $t('passwordsafetyrules') }}</v-list-item>
          <v-list-item :disabled="meta.disablechangepwconpw" class="text-caption pa-0 ml-5" v-for="key in ['useatleast8charactersandatleasttwoofthefollowingupperandlowercaselettersnumbersandspecialcharacters'
            ,'nomorethan4consecutivecharactersdigitsofthesameletternumber1111aaaetc','cantusemorethan3charactersonthekeyboardqweretc','previouslyusedpasswordsaredisabled','avoidusingthesamenumberasyourdateofbirthandphonenumber'
          ]">* {{ $t(key) }}</v-list-item>
        </v-list>
      </v-card-text>
      <v-card-actions>
        <v-row no-gutters justify="end">
          <v-col cols="3" class="pa-3">
            <v-btn variant="outlined" height="40" block :loading="meta.changepwbtnloading" @click="meta.visiblechangepw=false">{{ $t('cancel') }}</v-btn>
          </v-col>
          <v-col cols="3" class="pa-3">
            <v-btn variant="flat" color="primary" block height="40" :loading="meta.changepwbtnloading" @click="changepw"
              :disabled="validators.required(meta.newpasswd)!==true||validators.retypeBefore(meta.newpasswd,meta.newpasswdconfirm,'checksamepasscon')!==true">{{ $t('confirm') }}</v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<style scoped>
.v-list-item{min-height: 20px;}
</style>
